<template>
  <BusinessInformationUploadDocsList
    v-if="authorize == 'merchant' || authorize == 'supplier'"
    ref="BusinessInformationUploadDocsList"
  />
</template>

<script>
import Toolbar from '@/view/layout/header/Toolbar.vue';
import BusinessInformationUploadDocsList from '../components/BusinessInformationUploadDocsList.vue';
import roleMiddlewaresMixin from '@/core/mixins/roleMiddlewaresMixin';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      EventBus: null,
    };
  },
  mixins: [roleMiddlewaresMixin],
  computed: {
    ...mapGetters(['authorize']),
  },

  components: {
    Toolbar,
    BusinessInformationUploadDocsList,
  },
  methods: {
    saveHandler() {
      // save has Defined In Child Component
      this.$refs['BusinessInformationUploadDocsList'].save();
    },
    newHandler() {
      this.$refs['BusinessInformationUploadDocsList'].new();
    },
    listHandler() {
      this.$refs['BusinessInformationUploadDocsList'].showList();
    },
    returnToList() {
      this.$refs['BusinessInformationUploadDocsList'].returnToList();
    },
  },
};
</script>

<style></style>
